import {
    fetchPanelBrands,
    fetchRoofTypes,
} from '../../createProposalModal/actions';
import { fetchPresets } from '../../systems/actions';

import fetchParentFieldSegment from './fetchParentFieldSegment';

export default (id) => (dispatch) => {
    Promise.all([
        dispatch(fetchParentFieldSegment(id)),
        dispatch(fetchPanelBrands()),
        dispatch(fetchRoofTypes()),
        dispatch(fetchPresets()),
    ]);
};
